import { useMemo } from "react";
import { Box, Button, CloseIcon, Flex, Text, VStack } from "native-base";
import { useNavigate, useLocation } from "react-router-dom";
import StyledButton from "../../components/Button";

type LocationState = {
  materialName?: string;
  isRecyclable?: boolean;
  recycleUrl?: string;
};

function PinkRecycle() {
  const navigate = useNavigate();
  const location = useLocation();

  const state = (location.state ?? {}) as LocationState;

  const isRecyclable = state.isRecyclable ?? true;
  const materialName = state.materialName ?? "cotton";

  const copy = useMemo(() => {
    if (!isRecyclable) {
      return {
        title: "Recycle",
        headline: "Thanks for checking!",
        subheadline:
          "This garment can’t be recycled through our program right now.",
        body: "You can still extend its life by repairing, donating, or reusing it. If you’d like, we can guide you to the best option based on your location.",
        cta: "SEE OPTIONS",
      };
    }

    return {
      title: "Recycle",
      headline: "Great news!",
      subheadline: `This garment is 100% ${materialName}, so it can be recycled.`,
      body: "Find a store near you to drop off your garment for recycling with us, or send it to us and we will take care of it.",
      cta: "GO TO RECYCLE",
    };
  }, [isRecyclable, materialName]);

  const handleClose = () => navigate(-1);

  const handleCta = () => {
    window.open(
      "https://tilli.fr/reserver-votre-couturier-a-domicile/",
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <Flex
      minH="100vh"
      direction="column"
      justifyContent="space-between"
      bg="white"
    >
      <Box>
        <VStack alignItems="flex-start" space={4} px="4" pt="4">
          <Button onPress={handleClose} variant="unstyled" p="2">
            <CloseIcon color="black" size="5" />
          </Button>
        </VStack>

        <VStack alignItems="center" mb="4" px="4" space="6">
          <Text
            fontFamily="Unna"
            fontSize="36px"
            letterSpacing="0.46px"
            color="black"
          >
            {copy.title}
          </Text>
        </VStack>

        <VStack alignItems="center" px="4" space="4">
          <Text
            fontFamily="Unna"
            fontWeight="700"
            fontSize="18px"
            color="black"
            textAlign="center"
          >
            {copy.headline}
          </Text>

          <Text
            fontFamily="Unna"
            fontWeight="700"
            fontSize="18px"
            color="black"
            textAlign="center"
          >
            {copy.subheadline}
          </Text>

          <Text
            fontFamily="Unna"
            fontSize="12px"
            color="black"
            textAlign="center"
            px="2"
          >
            {copy.body}
          </Text>

          <Box w="100%" pt="6">
            <StyledButton
              fontSize={"20px"}
              fontFamily={"Unna"}
              text="GO TO RECYCLE"
              backgroundColor={"#EEA3AC"}
              textColor="black"
              borderColor="transparent"
              width="100%"
              height="54px"
              hoverBackgroundColor="#FFFFFF"
              hoverTextColor={"black"}
              hoverBorderColor={"black"}
              onClick={()=>{
                console.log('GO TO RECYCLE')
              }}
            />
          </Box>
        </VStack>
      </Box>
    </Flex>
  );
}

export default PinkRecycle;
